<template>
  <div class="recommend-rfq">
    <div class="recommend-rfq-head">
      <span class="recommend-rfq-head-tit">询盘推荐</span>
      <!-- <a class="recommend-rfq-head-link" href="javascript:(void 0)">偏好设置</a> -->
    </div>
    <ul v-if="!isLoading && recommendRfqList.length" class="recommend-rfq-main">
      <li 
        v-for="(item, index) in recommendRfqList" 
        :key="index" 
        class="recommend-rfq-item"
      >
        <div class="recommend-rfq-item-t">
          <div class="recommend-rfq-item-t-l">
            <div class="recommend-rfq-item-face">
              <img 
                class="recommend-rfq-item-face-img" 
                :src="`${partDrawingUrl}${item.partThumbnailsHashCode}&thn=100100`"
                :onerror="`this.src='${ defaultRfqThn }'`"
                alt="" 
              />
            </div>
            <div class="recommend-rfq-item-info">
              <h5 class="recommend-rfq-item-info-tit">
                <img class="from-country" :src="item.flagPath" alt="" />
                <a 
                  :class="{'readed-tit': item.read}"
                  :href="`${ onlineUrl }/supplier/rfq/detail/${ item.id }`"
                  target="_blank"
                >RFQ#{{ item.id }}{{ item.title ? '-' + item.title : '' }}</a>
              </h5>
              <div class="recommend-rfq-item-info-item">
                <span class="recommend-rfq-item-info-label">工艺:</span>
                <span class="recommend-rfq-item-info-value">{{ item.mainCategory }}</span>
              </div>
              <div class="recommend-rfq-item-info-item">
                <span class="recommend-rfq-item-info-label">数量:</span>
                <span class="recommend-rfq-item-info-value">{{ item.purchaseQuantity }}{{ item.purchaseQuantityUnit }}</span>
              </div>
              <div class="recommend-rfq-item-info-item">
                <span class="recommend-rfq-item-info-label">截止日期:</span>
                <span class="recommend-rfq-item-info-value">{{ item.validDate | handleFormatDate }}</span>
              </div>
            </div>
          </div>
          <div class="recommend-rfq-item-t-r">
            <el-button 
              @click="newTabLink(item.id)"
              type="primary" 
              size="small"
              class="need-quote"
            >我要报价</el-button>
            <span class="need-quote-msg">报价剩余<span class="need-quote-msg-red">{{ (item.validDate ? item.validDate + 24*60*60*1000*2 - 1000 : '') | handleNowToFutureDays }}</span>天</span>
          </div>
        </div>
        <div v-if="item.remark" class="recommend-rfq-item-b">
          <span class="recommend-rfq-item-b-label">备注:</span>
          <span class="recommend-rfq-item-b-value">{{ item.remark }}</span>
        </div>
      </li>
      <!-- ......... -->
      <li class="recommend-rfq-more">
        <a 
          class="recommend-rfq-more-link" 
          :href="`${ onlineUrl }/matched-rfqs/1`" 
          target="_blank"
        >查看全部匹配询盘</a>
      </li>
    </ul>
    <div v-if="!isLoading && recommendRfqList.length === 0" class="recommend-rfq-nolist">
      <img src="@/assets/image/common/noData.png" alt="" />
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
import { getFavoriteDict, getFavoriteRfqList, getRecommendMoreRfqList } from '@/utils/api/dashboard';
import { partDrawingUrl, onlineUrl } from '@/utils/config';
import { newTabLink } from '@/utils/common';
// import defaultRfqThn from '@/assets/image/common/default_rfq_thumb.png';

export default {
  data() {
    return {
      partDrawingUrl,
      onlineUrl,
      recommendRfqList: [],
      defaultRfqThn:"https://res.haizol.com/base/images/default_rfq_thumb_56_56.png",

      isLoading: false, //是否处于loading状态

    }
  },
  methods: {
    newTabLink(id) {
      const url = `${ onlineUrl }/supplier/rfq/detail/${ id }`;
      newTabLink(url);
    },
    // 获取是否为付费客户、是则判断是否设置了筛选条件，没设置就不补全
    getFavoriteDict() {
      this.isLoading = true;
      getFavoriteDict()
        .then(res=> {
          this.isLoading = false;
          if(res.rspResult.bizCode == 200) {
            if(res.data.paidMember) {
              // 是付费会员
              const _setting = res.data.supplierFavoriteSetting;
              if(_setting) {
                const isSettinged = Object.keys(_setting).some(key=> {
                  if(['quoteNumMin', 'quoteNumMax'].includes(key)) {
                    return _setting[key] || _setting[key] == 0;
                  }else if(key == 'areaMap') {
                    return Object.keys(_setting[key]).length;
                  }
                  return _setting[key] && _setting[key].length;
                })
                isSettinged && this.getRecommendMoreRfqList();
              }
            }
          }
        })
        .catch(err=> {
          this.isLoading = false;
          console.error('获取是否为付费客户、意向询盘筛选条件失败', err)
        })
    },
    // 先获取意向询盘列表，设置了意向询盘筛选条件，不够就拿“更多”推荐询盘去填充
    getFavoriteRfqList() {
      this.isLoading = true;
      const params = {
        curPage: 1,
        pageSize: 5,
        attribute: null,
        sortType: null
      }
      getFavoriteRfqList(params)
        .then(res=> {
          this.isLoading = false;
          if(res.rspResult.bizCode == 200) {
            this.recommendRfqList = res.rspPageData.list || [];
            if(this.recommendRfqList.length < 5) {
              this.getFavoriteDict();
            }
          }
        })
        .catch(err=> {
          this.isLoading = false;
          console.error('获取意向询盘列表失败', err)
        })
    },
    getRecommendMoreRfqList() {
      const params = {
        curPage: 1,
        pageSize: 5 - this.recommendRfqList.length,
        attribute: null,
        sortType: null
      }
      getRecommendMoreRfqList(params)
        .then(res=> {
          if(res.rspResult.bizCode == 200) {
            const list = res.rspPageData.list || [];
            this.recommendRfqList = this.recommendRfqList.concat(list);
          }else {
            
          }
        })
        .catch(err=> {
          console.error('获取推荐询盘列表失败', err)
        })
    }
  },
  created() {
    this.getFavoriteRfqList();
  },
}
</script>

<style lang="scss" scoped>
.recommend-rfq {
  &-head {
    height: 46px;
    padding: 0 16px 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    margin-bottom: 2px;
    &-tit {
      height: 14px;
      line-height: 14px;
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 14px;
      color: #16181A;
      letter-spacing: 0;
    }
    &-link {
      height: 14px;
      line-height: 14px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #066EB7;
      letter-spacing: 0;
    }
  }
  &-main {
    .recommend-rfq-item {
      background: #fff;
      margin-bottom: 2px;
      padding: 17px 20px 17px 16px;
      &-t {
        height: 123px;
        display: flex;
        justify-content: space-between;
        &-l {
          display: flex;
          padding-top: 1px;
          flex: 1;
          .recommend-rfq-item-face {
            width: 120px;
            height: 120px;
            text-align: center;
            background: #FFF;
            border: 1px solid #E5E8ED;
            border-radius: 1.54px;
            margin-right: 16px;
            flex-shrink: 0;
            line-height: 118px;
            overflow: hidden;
            &-img {
              // width: 100%;
              // height: auto;
              display: inline-block;
              max-width: 120px;
              max-height: 120px;
            }
          }
          .recommend-rfq-item-info {
            flex: 1;
            width: 0;
            &-tit {
              height: 28px;
              line-height: 28px;
              font-family: SourceHanSansCN-Bold;
              font-weight: 700;
              font-size: 14px;
              color: #16181A;
              letter-spacing: 0;
              margin-bottom: 13px;

              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              .from-country {
                width: 20px;
                line-height: 28px;
                margin-right: 5px;
              }
              a {
                &:visited {
                  font-family: SourceHanSansCN-Regular;
                  font-weight: 100;
                }
              }
              .readed-tit {
                font-family: SourceHanSansCN-Regular;
                font-weight: 100;
              }
            }
            &-item {
              margin-bottom: 16px;
              line-height: 14px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              font-size: 14px;
              letter-spacing: 0;
              .recommend-rfq-item-info-label {
                color: #4F5D78;
              }
              .recommend-rfq-item-info-value {
                margin-left: 12px;
                color: #16181A;
              }
            }
          }
        }
        &-r {
          margin-left: 30px;
          flex-shrink: 0;
          .need-quote {
            width: 96px;
            border-radius: 2px;
            border: 0;
            margin-bottom: 10px;
            ::v-deep span {
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              font-size: 14px;
              line-height: 14px;
              color: #FFFFFF;
              letter-spacing: 0;
            }
          }
          .need-quote-msg {
            display: block;
            width: 96px;
            height: 12px;
            line-height: 1;
            color: #16181aff;
            font-size: 12px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 400;
            letter-spacing: 0;
            text-align: center;
            &-red {
              color: #EF2A2A;
            }
          }
        }
      }
      &-b {
        margin-top: 14px;
        display: flex;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0;
        margin-bottom: 2px;
        margin-left: 138px;
        &-label {
          width: max-content;
          flex-shrink: 0;
          margin-right: 12px;
          color: #4F5D78;
        }
        &-value {
          flex: 1;
          width: 0;
          color: #FF6905;
          min-height: 18px;
          white-space: pre-line;
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    .recommend-rfq-more {
      width: 100%;
      height: 40px;
      text-align: center;
      padding-top: 2px;
      &-link {
        display: block;
        background: #fff;
        height: 40px;
        line-height: 40px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #4F5D78;
        letter-spacing: 0;
        &:hover {
          background: #fcfcfc;
        }
      }
    }
  }
}

.recommend-rfq-nolist {
  background: #fff;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 193px;
  }
  p {
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #98a3b7;
    margin-top: 16px;
  }
}
</style>